import {Button, ButtonPriority, HoverStyles, Spinner, TextButton} from '@wix/wix-ui-tpa/cssVars'
import classNames from 'classnames'
import React from 'react'
import {classes} from './event-link.st.css'
import {EventLinkProps} from './interfaces'

export const EventLink: React.FC<EventLinkProps> = ({primary, secondary, mobile, textButton, loading, ...rest}) => {
  if (textButton) {
    return <TextButton {...rest} className={classes.link} hoverStyle={HoverStyles.underline} />
  } else {
    let buttonPriority
    let buttonClass
    let spinnerClass

    if (primary) {
      buttonPriority = ButtonPriority.primary
      buttonClass = classes.primaryButton
      spinnerClass = classes.primarySpinner
    } else if (secondary) {
      buttonPriority = ButtonPriority.secondary
      buttonClass = classes.secondaryButton
      spinnerClass = classes.secondarySpinner
    }

    return (
      <div className={classNames(classes.container, {[classes.fullWidth]: mobile})}>
        {loading && (
          <div className={classes.spinnerWrapper}>
            <Spinner diameter={18} className={spinnerClass} />
          </div>
        )}
        <Button
          {...rest}
          className={classNames(buttonClass, {
            [classes.hidden]: loading,
          })}
          priority={buttonPriority}
          fullWidth={mobile}
          hoverStyle={HoverStyles.underline}
        />
      </div>
    )
  }
}
